import '../../App.css';

function ProductosQuimfaPoliticasPage() {
  return (
    <div style={{
      padding: '20px',
    }}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: 15 de enero de {new Date().getFullYear()}</p>
      <p>Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza Productos Quimfa. La aplicación está enfocada en mostrar catálogos de medicamentos.</p>

      <h2>Definiciones</h2>
      <ul>
        <li><strong>Aplicación</strong>: Se refiere a Quimfa Vademecum.</li>
        <li><strong>Dispositivo</strong>: Cualquier dispositivo que pueda acceder al Servicio, como un ordenador o un teléfono móvil.</li>
        <li><strong>Servicio</strong>: Se refiere a la Aplicación y sus funcionalidades, incluyendo la visualización de catálogos de medicamentos.</li>
        <li><strong>Usted</strong>: El individuo que accede o utiliza el Servicio.</li>
      </ul>

      <h2>Recopilación y Uso de sus Datos Personales</h2>
      <p>Productos Quimfa no recopila ni almacena datos personales de los usuarios. La aplicación no requiere inicio de sesión ni solicita información personal para su funcionamiento.</p>

      <h2>Uso de sus Datos Personales</h2>
      <p>Al no recopilar datos personales, no se realiza ningún uso de información personal de los usuarios.</p>

      <h2>Enlaces a Otros Sitios Web</h2>
      <p>El Servicio puede contener enlaces a otros sitios web que no son operados por nosotros. No tenemos control sobre el contenido, las políticas de privacidad o las prácticas de sitios o servicios de terceros.</p>

      <h2>Cambios a esta Política de Privacidad</h2>
      <p>Podemos actualizar nuestra Política de Privacidad de vez en cuando. Cualquier cambio será publicado en esta página. Le recomendamos revisar esta página periódicamente para estar al tanto de las actualizaciones.</p>

      <h2>Contáctenos</h2>
      <p>Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos por correo electrónico.</p>
    </div>
  );
}

export default ProductosQuimfaPoliticasPage;